import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useConfig } from '@xingternal/hops';

import JobRoleAutoComplete from './JobRoleAutoComplete/JobRoleAutoComplete';
import LocationAutoComplete from './LocationAutoComplete/LocationAutoComplete';
import { EXTENDED_FILTERS_SETTINGS, FILTERS_SETTINGS } from './constants';

import {
  InputsContainer,
  InnerContainer,
  StyledButton,
  FiltersContainer,
  Filter,
  StyledCheckbox,
} from './JobsSearch.style';

const JobsSearch = ({
  isJobsSearchVariantOneVersion,
  isJobsSearchVariantTwoVersion,
}) => {
  const { externalUrl } = useConfig();
  const { search } = useLocation();

  const filtersSettings =
    isJobsSearchVariantOneVersion || isJobsSearchVariantTwoVersion
      ? EXTENDED_FILTERS_SETTINGS
      : FILTERS_SETTINGS;

  const [jobRoleValue, setJobRoleValue] = useState('');
  const [locationValue, setLocationValue] = useState('');
  const [filtersValues, setFiltersValues] = useState({});

  const handleSubmit = event => {
    event.preventDefault();

    let baseUrl = `${externalUrl}/jobs/search`;
    let searchParams = search;

    searchParams += `${
      !searchParams ? '?' : '&'
    }sc_o=losp_jobs_search_button_click&sc_o_PropActionOrigin=losp_job_search`;

    if (jobRoleValue) {
      searchParams += `&keywords=${jobRoleValue}`;
    }
    if (locationValue) {
      searchParams += `&location=${locationValue}`;
    }
    if (filtersValues) {
      Object.keys(filtersValues).forEach(filterId => {
        if (filtersValues[filterId]) {
          searchParams += `&${filtersSettings[filterId].query}`;
        }
      });
    }

    window.location.href = new URL(searchParams, baseUrl).toString();
  };

  const handleFilterClick = id => {
    setFiltersValues(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const onCheckboxClick = event => {
    event.stopPropagation();
  };

  return (
    <form onSubmit={handleSubmit}>
      <InputsContainer>
        <InnerContainer>
          <JobRoleAutoComplete
            value={jobRoleValue}
            onValueChange={setJobRoleValue}
          />
        </InnerContainer>
        <InnerContainer>
          <LocationAutoComplete
            value={locationValue}
            onValueChange={setLocationValue}
          />
          <StyledButton variant="primary" size="large" onClick={handleSubmit}>
            <FormattedMessage
              id="WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON"
              defaultMessage="Search jobs"
            />
          </StyledButton>
        </InnerContainer>
      </InputsContainer>
      <FiltersContainer>
        {Object.keys(filtersSettings).map(filterType => (
          <Filter
            key={filterType}
            $isJobsSearchVariantOneVersion={isJobsSearchVariantOneVersion}
            onClick={() => handleFilterClick(filterType)}
          >
            <StyledCheckbox
              $isJobsSearchVariantOneVersion={isJobsSearchVariantOneVersion}
              name={filterType}
              on={!!filtersValues[filterType]}
              onChange={onCheckboxClick}
            />
            <FormattedMessage {...filtersSettings[filterType].message} />
          </Filter>
        ))}
      </FiltersContainer>
    </form>
  );
};

export default JobsSearch;
